import React, { useState, useEffect } from "react";
import { TabContent, Nav, NavItem, NavLink } from "reactstrap";
import styles from "./Response.module.css";
import { DetailTab, SimilarTab, WebTab } from "components/tabs";
import { ResponseActions } from "components/response";
import { ResponseType } from "data/Types";

const Tab = {
  DETAIL: "detail",
  SIMILAR: "similar",
  WEB: "web",
};

const ResponseDetail = ({
  response,
  className,
  style,
  handleClose,
  personal = false,
}) => {
  const [tab, setTab] = useState(Tab.DETAIL);

  const handleToggle = (t) => {
    if (tab !== t) setTab(t);
  };

  useEffect(() => {
    if (
      (tab === Tab.SIMILAR || tab === Tab.WEB) &&
      response.responseType === ResponseType.FILE
    ) {
      setTab(Tab.DETAIL);
    }
  }, [tab, response]);
  return (
    <div
      className={`${styles.detail}${className ? ` ${className}` : ""}`}
      style={style}
    >
      <ResponseActions
        response={response}
        handleClose={handleClose}
        detail
        personal={personal}
      />
      <h3 className={styles.title}>{response.title}</h3>
      <Nav tabs>
        <NavItem>
          <NavLink
            className={tab === Tab.DETAIL ? "active" : ""}
            onClick={() => {
              handleToggle(Tab.DETAIL);
            }}
          >
            Detail
          </NavLink>
        </NavItem>
        {response.responseType !== ResponseType.FILE && (
          <NavItem>
            <NavLink
              className={tab === Tab.SIMILAR ? "active" : ""}
              onClick={() => {
                handleToggle(Tab.SIMILAR);
              }}
            >
              Similar
            </NavLink>
          </NavItem>
        )}
        {response.responseType !== ResponseType.FILE && (
          <NavItem>
            <NavLink
              className={tab === Tab.WEB ? "active" : ""}
              onClick={() => {
                handleToggle(Tab.WEB);
              }}
            >
              Web
            </NavLink>
          </NavItem>
        )}
      </Nav>
      <TabContent activeTab={tab}>
        {tab === Tab.DETAIL && (
          <DetailTab
            tabId={Tab.DETAIL}
            response={response}
            className={styles.tabDetail}
          />
        )}
        {tab === Tab.SIMILAR && response.responseType !== ResponseType.FILE && (
          <SimilarTab
            tabId={Tab.SIMILAR}
            responseId={response.id}
            className={styles.tabPane}
          />
        )}
        {tab === Tab.WEB && response.responseType !== ResponseType.FILE && (
          <WebTab
            tabId={Tab.WEB}
            q={response.title}
            className={styles.tabPane}
          />
        )}
      </TabContent>
    </div>
  );
};

export { ResponseDetail };
